import styled from 'styled-components';

export const WrapperButton = styled.div`
    height:40px;
    margin-top: 30px;
    position: relative;
    && > button {
        height: 40px!important;
    }
`;